import { Controller } from "@hotwired/stimulus"

// Permalink button (card #3331) -- copies a shareable deep link to THIS
// slide (`#slide-N`, 1-based) to the clipboard, so a colleague can be
// pointed straight at a specific slide in Slack/email instead of "scroll to
// slide 3". The #slide-N hash navigation itself already works end to end
// (airdrop_report_viewer_controller.js#jumpToHash/#updateHash) -- this
// controller only constructs that URL client-side and copies it; no new
// route or param.
//
// slideIndexValue is the slide's 0-based position (threaded through from
// decks/_slide_list.html.erb's own loop `index`, or recomputed via
// find_index at the two live-broadcast call sites -- see
// decks/_slide_toolbar.html.erb's header comment on the `slide_index`
// local) -- the hash itself is 1-based, matching every other #slide-N
// reference in the app.
//
// clipboard_controller.js already has the established "flash a small icon
// button to a green checkmark for ~1.5s" visual convention -- but it reads
// a static sourceTarget.innerText, which doesn't fit here since the URL
// must be built dynamically from window.location rather than read off a
// DOM node. So this is a small new controller, but the flash below is
// copied verbatim from that one for visual consistency rather than
// inventing a different feedback style.
//
// `data-controller` sits directly on the `<button>` itself (matching the
// pins-toggle/hidden-toggle/prior-cycle-toggle buttons beside it in the
// same toolbar), with a separate `icon` target for the swap so the
// button's `sr-only` label text is left untouched by the flash.
export default class extends Controller {
  static targets = ["icon"]
  static values = { slideIndex: Number }

  copy(event) {
    event.preventDefault()

    const url = `${window.location.origin}${window.location.pathname}#slide-${this.slideIndexValue + 1}`
    navigator.clipboard.writeText(url)

    const originalIcon = this.iconTarget.innerHTML
    this.iconTarget.innerHTML = `<svg class="shrink-0 h-4 w-4 text-green-500 stroke-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
    </svg>`
    setTimeout(() => {
      this.iconTarget.innerHTML = originalIcon
    }, 1500)
  }
}
